angular.module('dpw.components')

  /**
   * @ngdoc component
   * @name dpwFreeSignUpBox
   */
    .component('dpwFreeSignUpBox', {
        bindings: {
          primaryText: '<',
          secondaryText: '<'
        },
        templateUrl: 'dpw-free-sign-up-box.html',
        controller: ['$window', 'trackUtil', 'mixpanelService', function ($window, trackUtil, mixpanelService) {
            var $ctrl = this;

            $ctrl.email = '';
            $ctrl.submit = function () {
                trackUtil.logPageView('Home:SignUpBox');

                mixpanelService.performTracking(mixpanelService.eventNames.SIGNUP_BUTTON_CLICK, {
                    'Signup Entry': 'Home page'
                }).then(function () {
                    $window.location.href = buildHref($ctrl.email);
                });
            };

            function buildHref(email) {
                var baseUrl = RCDPW.entries.freeTierSignUp.href;
                return _.isEmpty(email) ? baseUrl : [baseUrl, '#?email=', encodeURIComponent(email)].join('');
            }
        }]
    });
